import script from "./UserAgreement.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAgreement.vue?vue&type=script&setup=true&lang=js"

import "./UserAgreement.vue?vue&type=style&index=0&id=c9fbdbba&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9fbdbba"]])

export default __exports__